import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import Login from '@/views/Login.vue';
import CustomerReportSchedule from '@/views/CustomerReportSchedule.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true,
    meta: {
      requireLogin: false,
    },
  },
  {
    path: '/network-jobs',
    name: 'Network Jobs',
    component: Home,
    props: {
      jobType: 'Network',
    },
  },
  {
    path: '/network-collections',
    name: 'Network Collections',
    component: Home,
    props: {
      jobType: 'Network Collection',
    },
  },
  { path: '/customer-report-schedule', name: 'Customer Report Schedule', component: CustomerReportSchedule },
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: {
      jobType: 'Own',
    },
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.PUBLIC_PATH,
  routes,
});

export default router;
